import { render, staticRenderFns } from "./ItemOptions.vue?vue&type=template&id=c1952136&scoped=true&"
import script from "./ItemOptions.vue?vue&type=script&lang=js&"
export * from "./ItemOptions.vue?vue&type=script&lang=js&"
import style0 from "./ItemOptions.vue?vue&type=style&index=0&id=c1952136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1952136",
  null
  
)

export default component.exports